import { Component, OnChanges, OnDestroy, OnInit, ViewChild, SimpleChanges, ViewEncapsulation, Input } from '@angular/core';
import { concat, Subject, Subscription } from 'rxjs';
import { map, tap, concatMap, filter, switchMap, debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { LazyLoadEvent, MenuItem, MessageService, FilterMetadata } from 'primeng/api';
import { Table } from 'primeng/table';

import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { CliListEntry } from 'src/app/shared/cli-list-entry';
import { DocListEntry, DocTypes } from 'src/app/shared/doc-list-entry';
import { DoclistQueryParams } from 'src/app/shared/doclist-query-params';
import { DocumentListViewType } from 'src/app/shared/document-list-view-type';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { Product } from 'src/app/shared/product';

@Component({
  selector: 'app-list-documents-for-product',
  templateUrl: './list-documents-for-product.component.html',
  styleUrl: './list-documents-for-product.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ListDocumentsForProductComponent implements OnInit, OnDestroy, OnChanges {

  globalSettinsData: GlobalSettingsData;
  todaydate: Date;

  parentCompany: number;

  @Input() prodId: number = 0;

  @Input() product: Product = null;      // Main client entity (balance)

  datasource: DocListEntry[]; // All documents for stated period (and global filter)
  dlTemp: DocListEntry[];     // All documents with table filter applied
  dlCurr: DocListEntry[];     // Visible part (table's value property) of dlTemp

  selectedDocument: DocListEntry;

  selectedDocTypes: DocTypes[];
  docTypes: DocTypes[];

  documentGlobalFilter: string;

  documentNumberFilter: string;
  documentAuthorFilter: string;
  documentCompanyFilter: string;
  documentNote1Filter: string;
  documentNote2Filter: string;

  documentDOCSUMFilter: number;
  documentPAYDSUMFilter: number;
  documentSHIPSUMFilter: number;

  selectedSellerCompany: CliListEntry[];
  sellerCompany: CliListEntry[];

  private docListQuery: Subscription;
  private docTypeQuery: Subscription;
  private selListQuery: Subscription;

  totalRecords: number;
  rows: number = 25;
  first: number;

  loading: boolean = false;

  filterDate: Date[];
  doclistDateRange: Date[];

  _filterSettings: DoclistQueryParams;
  tableFilterState: FilterMetadata;

  filterStoreName: string = 'clientDocumentListFilter';
  rowsStoreName: string = 'clientDocumentListRows';
  showColStoreName: string = 'clientDocumentShowCurCol';
  showNameStoreName: string = 'clientDocumentShowFullName';

  public get canExport(): boolean { return (this.dlCurr || []).length > 0; }

  private _docSubscriptionQuery: Subscription;

  private listOptions$ = new Subject<{ product: number, view: number, fromdate: Date }>();

  showFullNameColumn: boolean = false;

  selectAllTypes: boolean = false;
  selectAllCompanies: boolean = false;

  @ViewChild('dt') table: Table;

  constructor(
    private docApi: DocumentApiService,
    private cliApi: ClientApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      environment.production || console.log('*** ListDocumentsForProductComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'product':
          if (change.currentValue) {
            this.prodId = change.currentValue.PRODID;
          }

        case 'prodId':
          environment.production || console.log('*** ListDocumentsForProductComponent ngOnChanges (case prodId): ' + this.prodId);
          environment.production || console.log('*** ListDocumentsForProductComponent ngOnChanges (case prodId): ' + JSON.stringify(this.doclistDateRange));
          if (this.doclistDateRange) {
            this.listOptions$.next({ product: this.prodId, view: DocumentListViewType.ALL, fromdate: this.doclistDateRange[0] });
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** ListDocumentsForProductComponent ngOnDestroy: ')
    localStorage.setItem(this.filterStoreName, JSON.stringify(this._filterSettings));
    localStorage.setItem(this.rowsStoreName, JSON.stringify(this.table.rows));
    localStorage.setItem(this.showNameStoreName, JSON.stringify(this.showFullNameColumn));

    if (this.docListQuery) { this.docListQuery.unsubscribe(); }
    if (this.docTypeQuery) { this.docTypeQuery.unsubscribe(); }
    if (this.selListQuery) { this.selListQuery.unsubscribe(); }
    if (this._docSubscriptionQuery) { this._docSubscriptionQuery.unsubscribe(); }
  }

  updateDataTable() {
    if (this.datasource) {
      console.log('*** ListDocumentsForProductComponent Lazy Load initiated: datasource is valid');
      environment.production || console.table(this.table.filters);

      this.datasource.forEach(dc => dc.PARTNERNAMESTR = (dc.DOCCLIENTSID == dc.DOCPCOCLIID) ? dc.CLIENTSNAME : dc.PARTNERNAME + ' (' + dc.CLIENTSNAME + ')');

      this.dlTemp = this.datasource
        .filter(doc => {
          let fit: Boolean = true;

          if (this.table && this.table.filters) {
            for (let f in this.table.filters) {
              let fltItem = Array.isArray(this.table.filters[f]) ? this.table.filters[f] : [this.table.filters[f]];

              if (Array.isArray(fltItem) && (fltItem.length > 0)) {
                for (let i = 0; i < fltItem.length; i++) {
                  let flt = fltItem[i];
                  let fltValue = (typeof flt['value'] === 'string') ? flt['value'].trim().toLowerCase() : flt['value'];

                  //  console.log('table flt : ' + JSON.stringify(flt['value']));
                  if (fltValue) {
                    switch (f) {
                      case 'DOCDATE':
                        if (doc.DOCDATE) {
                          let docDate: Date = new Date(doc.DOCDATE);
                          docDate = new Date(docDate.getFullYear(), docDate.getMonth(), docDate.getDate());

                          fit = (
                            (fltValue[0] ? (docDate >= new Date(fltValue[0])) : true) &&
                            (fltValue[1] ? (docDate <= new Date(fltValue[1])) : true));
                          //console.log('DOCDATE   : ' + doc.DOCDATE + ' is ' + fit);
                        }
                        break;

                      case 'DOCTYPEID':
                        fit = fltValue.find(e => e.DOCTYPEID == doc.DOCTYPEID);
                        break;

                      case 'LOCALCOMP':
                        fit = fltValue.find(e => e.CLIID == doc.LOCALCOMPID);
                        break;

                      case 'CURID':
                        fit = fltValue.find(e => e.CURID == doc.DOCCURRID);
                        break;

                      case 'DOCNUMBER':
                      case 'AUTHOR':
                      case 'DOCNOTE1':
                      case 'DOCNOTE2':
                        fit = doc[f] && doc[f].toLowerCase().indexOf(fltValue) !== -1;
                        break;

                      case 'CLIENTSNAME':
                      case 'PARTNERNAMESTR':
                        fit = (doc[f] && (doc[f].toLowerCase().indexOf(fltValue) !== -1))
                          || ((doc.PARTNERNAME && doc.PARTNERNAME.toLowerCase().indexOf(fltValue) !== -1))
                          || ((doc.CLIENTSNAME && doc.CLIENTSNAME.toLowerCase().indexOf(fltValue) !== -1))
                          || ((doc.PARTNERNIKNAME && doc.PARTNERNIKNAME.toLowerCase().indexOf(fltValue) !== -1))
                          ;
                        break;

                      case 'DOCSUM':
                      case 'PAYDSUM':
                      case 'SHIPSUM':
                        let f1 = parseFloat(fltValue) || 0;
                        fit = (((f1 == 0) && (doc[f] == 0)) || ((f1 > 0) && (doc[f] > f1)));
                        break;

                      case 'global':
                        break;

                      default:
                        console.log(JSON.stringify(f));

                    }
                  }
                }
              }
              if (!fit) break;
            }
          }
          return fit;
        });

      this.dlCurr = (this.table) ? this.dlTemp.slice(this.table.first, (this.table.first + this.table.rows)) : this.dlTemp;

      let jn: Date = new Date();
      let td: Date = new Date();
      td.setHours(0, 0, 0, 0);
      let tm: Date = new Date(td);
      tm.setHours(23, 59, 59);

      this.dlCurr.forEach((dc: DocListEntry) => {
        dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

        dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

        dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

        dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

        dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

        dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

        dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

        dc.fd = (new Date(dc.DOCDATE) > tm);
      });

      this.totalRecords = this.dlTemp.length;
      this.loading = false;
    }
  }

  doLoadDocumentList() {
    console.log('*** ListDocumentsForProductComponent doLoadDocumentList')

    this.listOptions$.next({ product: this.prodId, view: DocumentListViewType.ALL, fromdate: this.doclistDateRange[0] });
  }

  doInitAllData() {
    this.todaydate = new Date();
    let fromdate = new Date(this.todaydate.getFullYear(), this.todaydate.getMonth() - 100, this.todaydate.getDate(), 0);

    // Set to End of current day
    //
    // Just a moment before tomorrow begins
    // But looks like today date

    this.todaydate = new Date(this.todaydate.getFullYear(), this.todaydate.getMonth(), this.todaydate.getDate(), 23, 59, 59, 999);
    this.doclistDateRange = [...[fromdate, this.todaydate]];
    this.filterDate = [...[fromdate, this.todaydate]];

    this._filterSettings = {
      USERSID: 0,
      DATERANGE: [fromdate, this.todaydate],
      GLOBAL: '',

      // DataTable Filter Parameters
      DOCTYPEID: [],
      DOCNUMBER: '',
      DOCDATE: null,
      DOCCURRID: [],
      DOCAUTHOR: '',
      DOCCLIENT: '',
      DOCSUM: null,
      DOCPAYD: null,
      DOCSHIP: null,
      DOCNOTE1: '',
      DOCNOTE2: ''
    };

    /*
     * TODO: Rewrite to concurent load
     */

    this.selListQuery =
      concat(
        this.cliApi.getCliChildList(this.parentCompany).pipe(map(data => this.sellerCompany = data)),

        this.docApi.getDocTypes().pipe(map(types => this.docTypes = types)),

      ).subscribe();

    this._docSubscriptionQuery =
      this.listOptions$.pipe(
        debounceTime(100),
        filter(opt => ((opt !== null) && opt.product !== null)),
        distinctUntilChanged(),

        tap(() => this.loading = true),

        switchMap(opt => this.docApi.getDocListDateByProduct(opt.product, opt.view, opt.fromdate, '', '', '', '').pipe(
          map(data => this.datasource = data),

          finalize(() => {
            this.updateDataTable();
          })
        ))).subscribe();

    this.doLoadDocumentList();
  }

  ngOnInit(): void {
    console.log('*** ListDocumentsForProductComponent onInit: ===> Starts')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.parentCompany = this.globalsettingsservice.getMainCompanyId();

    let _storedFilterSettings: string;
    _storedFilterSettings = localStorage.getItem(this.filterStoreName);
    if (_storedFilterSettings) { this._filterSettings = JSON.parse(_storedFilterSettings); }

    _storedFilterSettings = localStorage.getItem(this.rowsStoreName);
    if (_storedFilterSettings) { this.rows = JSON.parse(_storedFilterSettings); }

    _storedFilterSettings = localStorage.getItem(this.showNameStoreName);
    if (_storedFilterSettings) { this.showFullNameColumn = JSON.parse(_storedFilterSettings); }

    this.doInitAllData();
  }

  loaddl(event: LazyLoadEvent) {
    //in a real application, make a remote request to load data using state metadata from event
    //event.first = First row offset
    //event.rows = Number of rows per page
    //event.sortField = Field name to sort with
    //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
    //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

    this.updateDataTable();
  }

  onDocTypeChange(event) {
    this.table.filter(event.value, 'DOCTYPEID', 'in');
  }

  onAllDocTypeChange(event) {
    this.selectedDocTypes = event.checked ? [...this.docTypes] : [];
    this.selectAllTypes = event.checked;
    this.table.filter(this.selectedDocTypes, 'DOCTYPEID', 'in');
  }

  onSellerChange(event) {
    this.table.filter(event.value, 'LOCALCOMP', 'in');
  }

  onAllSellerChange(event) {
    this.selectedSellerCompany = event.checked ? [...this.sellerCompany] : [];
    this.selectAllCompanies = event.checked;
    this.table.filter(this.selectedSellerCompany, 'LOCALCOMP', 'in');
  }

  onDateRangeChange(event) {
    this.table.filter(this.filterDate, 'DOCDATE', 'between');
  }

  onDateRangeClear(event) {
    this.filterDate = [... this.doclistDateRange];
    this.table.filter(this.filterDate, 'DOCDATE', 'between');
  }

  onTodayClick(event) {
    let fromdate = new Date();
    fromdate = new Date(fromdate.getFullYear(), fromdate.getMonth(), fromdate.getDate(), 0); // Start of current day

    this.filterDate = [...[fromdate, this.doclistDateRange[1]]];
    this.table.filter(this.filterDate, 'DOCDATE', 'between');
  }

  handleFilter(e) {
    this.tableFilterState = e.filters;
  }

  updateDlFilterStatus(event, n: string, m: string) {
    this._filterSettings.DATERANGE[0] = this.doclistDateRange[0];
    this._filterSettings.DATERANGE[1] = this.doclistDateRange[1];

    this._filterSettings.DOCTYPEID = null;
    this._filterSettings.DOCNUMBER = null;
    this._filterSettings.DOCDATE = null;
    this._filterSettings.DOCCURRID = null;
    this._filterSettings.DOCAUTHOR = null;
    this._filterSettings.DOCCLIENT = null;
    this._filterSettings.DOCSUM = null;
    this._filterSettings.DOCPAYD = null;
    this._filterSettings.DOCSHIP = null;
    this._filterSettings.DOCNOTE1 = null;
    this._filterSettings.DOCNOTE2 = null;
  }

  onStateRestore(state) {
    // console.log('*** ListDocumentsForProductComponent onStateRestore: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        environment.production || console.log('*** ListDocumentsForProductComponent onStateRestore state.filters[' + f + ']: ' + JSON.stringify(state.filters[f]));
        let fltItem = state.filters[f];
        let fltValue = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;

        switch (f) {
          case 'DOCDATE':
          case 'DATERANGE':
            // Do not remeber the filtered dates
            // Becase next day you wouldn't see new documents

            let actualTodayDate = new Date();
            actualTodayDate = new Date(actualTodayDate.getFullYear(), actualTodayDate.getMonth(), actualTodayDate.getDate(), 23, 59, 59, 999);

            this.filterDate = (actualTodayDate > this.todaydate) ? [] : [...fltValue];

            break;

          case 'DOCTYPEID':
            this.selectedDocTypes = fltValue;
            break;

          case 'LOCALCOMP':
            this.selectedSellerCompany = fltValue;
            break;

          case 'DOCNUMBER':
            this.documentNumberFilter = fltValue;
            break;

          case 'AUTHOR':
            this.documentAuthorFilter = fltValue;
            break;

          case 'CLIENTSNAME':
          case 'PARTNERNAMESTR':
            this.documentCompanyFilter = fltValue;
            break;

          case 'DOCNOTE1':
            this.documentNote1Filter = fltValue;
            break;

          case 'DOCSUM':
            this.documentDOCSUMFilter = fltValue;
            break;

          case 'PAYDSUM':
            this.documentPAYDSUMFilter = fltValue;
            break;

          case 'SHIPSUM':
            this.documentSHIPSUMFilter = fltValue;
            break;

          case 'DOCNOTE2':
            this.documentNote2Filter = fltValue;
            break;

          case 'global':
            this.documentGlobalFilter = fltValue;
            break;

          default:
            environment.production || console.log(JSON.stringify(f));
        }
      }
    }

    if (state.rows) {
      this.rows = state.rows;
    }

    if (state.selection) {
      this.selectedDocument = state.selection;
    }
  }

  clearFilterStates() {
    this.documentNumberFilter = '';
    this.documentAuthorFilter = '';
    this.documentCompanyFilter = '';
    this.documentNote1Filter = '';
    this.documentNote2Filter = '';
    this.documentDOCSUMFilter = null;
    this.documentPAYDSUMFilter = null;
    this.documentSHIPSUMFilter = null;
    this.selectedDocTypes = [];
    this.selectedSellerCompany = [];
    this.filterDate = this.doclistDateRange;
    this.table.clearState();
    this.table.reset();
    //    this.table.clear();
    this.table.filters = {};

    this.rows = 25;
  }

  clearOrResetTableFilter(event) {
    console.log('*** ListDocumentsForProductComponent clearOrResetTableFilter: Hey! I call you! ' + JSON.stringify(event));
    this.clearFilterStates();

    this.listOptions$.next({ product: this.prodId, view: DocumentListViewType.ALL, fromdate: this.doclistDateRange[0] });
  }

  onReloadAllData(event) {
    console.log('*** ListDocumentsForProductComponent onReloadAllData: ' + JSON.stringify(event));

    this.listOptions$.next({ product: this.prodId, view: DocumentListViewType.ALL, fromdate: this.doclistDateRange[0] });
  }

  /*
   * TODO: need scrollTo selected document
   * may be play with x/y and viewport????
   *
   * */
  scrollToDocument(docId: number) {
    console.log('*** ListDocumentsForProductComponent scrollToDocument: entering with index: ' + docId);
    let index = this.dlTemp.findIndex((e) => { return (e.DOCID == docId); })

    if (index >= 0) {
      console.log('*** ListDocumentsForProductComponent scrollToDocument: find index: ' + index);
      console.log('*** ListDocumentsForProductComponent scrollToDocument: find page: ' + Math.trunc(index / this.rows));
      this.table.first = this.rows * Math.trunc(index / this.rows);
      this.dlCurr = this.dlTemp.slice(this.table.first, (this.table.first + this.table.rows));
      this.selectedDocument = this.dlTemp[index];
      console.log('*** ListDocumentsForProductComponent scrollToDocument: selection: ' + JSON.stringify(this.selectedDocument));
    }
  }

  onShowFullNameColumnChange(event) {
    console.log('*** ListDocumentsForProductComponent onShowFullNameColumnChange: ' + JSON.stringify(event))
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });

      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onExportData() {
    console.log('*** ListDocumentsForProductComponent onExportData: ')

    import("xlsx").then(xlsx => {

      let exportData: any =
        this.dlCurr.map(e => ({
          'Документ': e.DOCNAME,
          'Номер': e.DOCNUMBER,
          'Дата': new Date(e.DOCDATE),
          'Покупатель': e.CLIENTSNAME,
          'Ответственный': e.PERSONNAME,
          'Продавец': e.LOCALCOMP,
          'Менеджер': e.AUTHOR,
          'Сумма': e.DOCSUM,
          'Оплачено': e.PAYDSUM,
          'Отгружено': e.SHIPSUM,
          'Валюта': e.CURSTR,
          'Курс': e.DOCRATEVAL,
          'Примечание продавца': e.DOCNOTE1,
          'Примечание покупателя': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { documents: worksheet }, SheetNames: ['documents'] };

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      this.saveAsExcelFile(excelBuffer, "documents");
    });
  }
}

